import { gql } from '@apollo/client';

export const DELETE_LEASING_COMMISSION = gql`
  mutation deleteLeasingCommission($input: DeleteLeasingCommissionInput) {
    deleteLeasingCommission(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_LEASING_COMMISSION = gql`
  mutation saveLeasingCommission($input: SaveLeasingCommissionInput) {
    saveLeasingCommission(input: $input) {
      commandId
      correlationId
    }
  }
`;
